import * as Yup from "yup";

const CreateUserReferralCodeValidation = Yup.object().shape({
  marketingCode: Yup.string().test("len", (value, { createError }) => {
    let invalids = [];
    if (!value) return createError({ message: "نمی تواند خالی باشد" });
    if (!/^[a-zA-Z0-9@#\)\(+=._-]+$/.test(value))
      invalids.push("دارای کاراکتر غیر مجاز است");
    if (value.length > 50) invalids.push("از 50 کاراکتر باید کمتر باشد");
    if (value.length < 4) invalids.push("از 4 کاراکتر باید بیشتر باشد");
    return invalids.length == 0
      ? true
      : createError({ message: invalids.reduce((a, b) => a + ` -${b}`, "") });
  }),
  firstUserDiscount: Yup.number("لطفا عدد را بین 5 و 20 وارد نمایید")
    .min(0)
    .max(70),
  anotherUserDiscount: Yup.number("لطفا عدد را بین 3 و 6 وارد نمایید")
    .min(0)
    .max(20),
});

export { CreateUserReferralCodeValidation };
